@import (reference) '../../../../constants/spacing.module.less';

.section-header {
  gap: @space-8;
  justify-content: space-between;

  .section-title {
    margin: @space-0;
  }
}

.import-btn {
  display: flex;
  align-items: center;
  gap: @space-4;
  font-size: 14px;
  color: var(--blue-600);
}

.import-icon {
  height: 12px;
  width: 12px;
}

.section-description {
  color: var(--grey-600);
  margin-top: @space-8;
}
